import React from 'react';
import { Link } from 'react-router-dom';
const Intro = () => {
    return (
        <div className="container intro-container">
            <div className="row justify-content-center">
                <div className="col-md-7">
                    <p className='textGreen font'>Hello, I'm</p>
                    <h5 className='textLight2'>Rajon Ahmed.</h5>
                    <h5 className='introline'>I build things for the mobile & web.</h5>
                    <div className='intro-description'>
                        <p style={{ color: '#8892b0' }}>I’m a Front-end developer specializing in building modern  web \ mobile apps. Currently, I’m focused on building accessible, human-centered products at  <a href='https://www.asyncen.com/' target='_blank' className='asyncen'>Asyncen</a> </p>
                    </div>

                    <div className="mt-4">
                        <Link to="/about"><button type="button" className="me-4 btn btn-success">About me</button></Link>
                        <a href="https://www.linkedin.com/in/rajon-ahmed749/" target="_blank" rel="noreferrer"><button type="button" className="btn btn-outline-success">Contact</button></a>
                    </div>
                </div>
                <div className="col-md-3 mt-2">
                    <p> </p>
                </div>
            </div>
        </div>
    );
};

export default Intro;